import React from 'react'
import logo from '../../../assets/images/brandlogo.png';
import './ParentsMainHeader.css'

export default function ParentsMainHeader() {
  return (
    <>
      <header className='parentmainHeader'>
        <div className='parentmainheaderContent'>
          <div className='container'>
            <nav className='parentmainheaderNav parentmainheadernavExpand flex-wrap'>
              <div className='parentmainheaderLeft me-auto'>
                <a href="https://www.authormeet.net/" >
                  <div className='parentmainheaderBrand d-flex align-items-start'>
                    <img src={logo} className='parentmainheaderBrandimage img-fluid' />
                    <div className='parentmainheaderbrandTitles'>
                      <h6> AuthorMeet </h6>
                      <p> Powered by: Bookworm Central </p>
                    </div>
                  </div>
                </a>
              </div>

            </nav>
          </div>
        </div>
      </header>
    </>
  )
}
